import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import {
  type DeviceScreenCaptureResponse,
  getDeviceScreenCapture,
} from 'api/admin/washboard/washboard';

export const SCREEN_CAPTURE_REFRESH_INTERVAL_MS = 60_000;

export const useWashboardDeviceScreenCapture = (
  deviceId: number,
): {
  data?: DeviceScreenCaptureResponse;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  error: AxiosError<{ error: string }> | null;
  refetch: () => void;
} => {
  const result = useQuery<
    DeviceScreenCaptureResponse,
    AxiosError<{ error: string }>
  >({
    queryKey: ['washboardDeviceScreenCapture', deviceId],
    queryFn: async () => {
      const { data } = (await getDeviceScreenCapture(
        deviceId,
      )) as AxiosResponse<DeviceScreenCaptureResponse>;

      return data;
    },
    onError: (error) => {
      Sentry.captureException(error);
    },
    enabled: !!deviceId,
    retry: false,
    refetchInterval: SCREEN_CAPTURE_REFRESH_INTERVAL_MS,
    refetchOnWindowFocus: false,
  });

  return {
    data: result.data,
    isLoading: result.isLoading,
    isFetching: result.isFetching,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
  };
};
